<template>
  <vx-card>
    <h3 class="gw-det-title">Restricciones en la información</h3>
    <p class="gw-det-sub">
      Lo que no se pudo verificar, o se verificó con reservas.
    </p>

    <div class="gw-restr">
      <div
        v-for="(restriction, index) in restricciones"
        :key="index"
        class="gw-det-fila"
      >
        <div class="gw-det-fecha">{{ humanizeDate(restriction.created_at) }}</div>
        <div class="gw-det-texto">{{ restriction.observation }}</div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: 'ProjectRestrictions',
  props: {
    project: { type: Object, required: true }
  },
  computed: {
    restricciones () {
      var r = (this.project || {}).observation_restrictions
      return Array.isArray(r) ? r : []
    }
  },
  methods: {
    humanizeDate (date) {
      if (!date) return ''
      var partes = String(date).split('T')
      if (partes.length < 2) return String(date)
      return partes[0] + ', ' + partes[1].split('.')[0]
    }
  }
}
</script>

<style scoped>
.gw-restr{
  border-left: 3px solid #f0dcd8;
  padding-left: 14px;
}
</style>
